import * as React from "react";
import ETACalculator from "~/components/ETACalculator/ETACalculator";

interface IState {
  open: boolean;
  orderDate: Date;
  withTrackAndTrace: boolean;
}

const addBusinessDays = (date: Date, businessDays: number) => {
  let days = 0;
  const currentDate = new Date(date);

  while (days <= businessDays) {
    if (currentDate.getDay() % 6 > 0) {
      days++;
    }

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return currentDate;
};

export default class ETACalculatorContainer extends React.Component<
  {},
  IState
> {
  public readonly state = {
    open: false,
    orderDate: new Date(),
    withTrackAndTrace: false
  };

  public render() {
    const { orderDate, withTrackAndTrace, open } = this.state;

    return (
      <ETACalculator
        open={open}
        orderDate={orderDate}
        withTrackAndTrace={withTrackAndTrace}
        estimate={this.calculateEstimate(orderDate, withTrackAndTrace)}
        onOrderDateChange={this.handleOrderDateChange}
        onToggle={this.handleToggle}
        onWithTrackAndTraceChange={this.handleWithTrackAndTraceChange}
      />
    );
  }

  private calculateEstimate(orderDate: Date, withTrackAndTrace: boolean) {
    const estimatedDaysLower = withTrackAndTrace ? 15 : 25;
    const estimatedDaysUpper = withTrackAndTrace ? 25 : 30;

    return {
      lower: addBusinessDays(orderDate, estimatedDaysLower),
      upper: addBusinessDays(orderDate, estimatedDaysUpper)
    };
  }

  private handleOrderDateChange = (orderDate: Date) => {
    this.setState({ orderDate });
  };

  private handleWithTrackAndTraceChange = (withTrackAndTrace: boolean) => {
    this.setState({ withTrackAndTrace });
  };

  private handleToggle = () => this.setState(state => ({ open: !state.open }));
}



// WEBPACK FOOTER //
// ./src/containers/ETACalculator/ETACalculatorContainer.tsx